var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('timeline',{on:{"remove-interaction":function($event){return _vm.$emit('remove-interaction', $event)},"scheduled-interaction-realized":function($event){return _vm.$emit('scheduled-interaction-realized', $event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7b73190","hasScoped":true,"transformToRequire":{"img":["src","data-src","data-src-retina"]},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/CRM/Interactions/List.vue
// module id = 2028
// module chunks = 0